// @flow

import React from 'react'
import DetailPhotos from 'components/molecules/room/DetailPhotos'
import DetailVideo from 'components/molecules/room/DetailVideo'
import DetailVR from 'components/molecules/room/DetailVR'

export type PropTypes = {
  photos: Array<{
    url: string,
    caption: string,
  }>,
  onClickPhoto: Function,
  videoUrl: string,
  vrUrl: string,
}

export default (props: Object) => (
  <section className="space-main__section">
    <DetailPhotos photos={props.photos} onClickPhoto={props.onClickPhoto} />
    <DetailVR url={props.vrUrl} />
    <DetailVideo url={props.videoUrl} />
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailMediaSection/index.jsx